'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _terminal = require('./terminal');

var _terminal2 = _interopRequireDefault(_terminal);

var _alfa = require('./alfa');

var _alfa2 = _interopRequireDefault(_alfa);

var _qiwi = require('./qiwi');

var _qiwi2 = _interopRequireDefault(_qiwi);

var _static = require('./static');

var _static2 = _interopRequireDefault(_static);

var _utils = require('helpers/utils');

var _paymentSlug = require('components/Order/paymentSlug');

var _reactRedux = require('react-redux');

require('./style.less');

var _utils2 = require('containers/Order/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ProcessInput: {
        displayName: 'ProcessInput'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/index.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ProcessInput = _wrapComponent('ProcessInput')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        predefinedInstructions: (0, _utils2.extractInstructions)(state.payment.pipoList)
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ProcessInput, _Component);

    function ProcessInput() {
        (0, _classCallCheck3.default)(this, ProcessInput);
        return (0, _possibleConstructorReturn3.default)(this, (ProcessInput.__proto__ || (0, _getPrototypeOf2.default)(ProcessInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(ProcessInput, [{
        key: 'injectPredefinedInstructions',

        // TODO: Пока не нужен, если не будет в будущем использоваться можно удалить
        value: function injectPredefinedInstructions(data) {
            var result = (0, _extends3.default)({}, data);

            if (this.props.predefinedInstructions) {
                for (var slug in this.props.predefinedInstructions) {
                    if (result.slug === slug) {
                        result.labels = (0, _extends3.default)({}, result.labels, {
                            instruction: this.props.predefinedInstructions[slug]
                        });
                    }
                }
            }

            return result;
        }
    }, {
        key: 'render',
        value: function render() {

            // const data = this.injectPredefinedInstructions(this.props.data);
            var data = this.props.data;


            if (this.props.data.slug === _paymentSlug.TERMINAL) {
                return _react3.default.createElement(_terminal2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
            } else if (this.props.data.slug === _paymentSlug.ALFABANK_SLUG) {
                return _react3.default.createElement(_alfa2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
            } else if ((0, _paymentSlug.isQiwiSlug)(this.props.data.slug)) {
                return _react3.default.createElement(_qiwi2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
            } else if (this.props.data.slug === _utils.PAY_COURIER_SLUG || this.props.data.slug === _utils.PAY_PICKUP_SLUG) {
                return _react3.default.createElement(_static2.default, { data: data, orderId: this.props.orderId, products: this.props.products, sumTotal: this.props.sumTotal });
            }

            return _react3.default.createElement('div', null);
        }
    }]);
    return ProcessInput;
}(_react2.Component), _class2.propTypes = {
    data: _react2.PropTypes.object.isRequired,
    orderId: _react2.PropTypes.number.isRequired
}, _temp)) || _class));

exports.default = ProcessInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/ProcessInput/index.jsx
// module id = 1709
// module chunks = 0